export default async function handler () {
  this.text = this.$tf('Sending petition')
  this.actions = [
    {
      title: this.$tf('Go to login'),
      color: 'primary',
      callback () {
        this.$store.dispatch('session/destroySession').then(
          () => {
            this.$router.push('/')
          }
        )
      }
    }
  ]
  this.loading = true

  try {
    await this.$services.accounts
      .account(this.$route.query.account_id)
      .update({
        params: {
          token: this.$route.query.token
        },
        data: {
          active: true
        },
        skipAuth: true
      })

    this.text = this.$tf('Your account has been activated successfully')
  } catch (response) {
    this.text = this.$tf('Something went wrong activating your account')
    this.text += `<br/>` + this.$tf('Try again later')
  } finally {
    this.loading = false
  }
}



// WEBPACK FOOTER //
// ./src/components/views/simple-api-requests/request-handlers/AccountRestoration.js